export default [
    {
        path: '/food',
        name: 'Food_List',
        component: () => import('@/views/reservation/food/list.vue'),
        meta: {
            authRequired: true,
            permission: 'foods.index'
        }
    },
    {
        path: '/food/create',
        name: 'Food_Create',
        component: () => import('@/views/reservation/food/create.vue'),
        meta: {
            authRequired: true,
            permission: 'foods.store'
        }
    },
    {
        path: '/food/:id/edit',
        name: 'Food_Edit',
        component: () => import('@/views/reservation/food/edit.vue'),
        meta: {
            authRequired: true,
            permission: 'foods.show',
            navActiveLink:'Food_List'
        }
    },
]
